import { cssVars } from '@/app/styles';
import { InvisibleButton } from '@/widgets/components/invisible-button';
import { Icon } from '@iconify/react';
import { Tooltip } from 'rsuite';
import styled, { css, keyframes } from 'styled-components';

export const NavItemSectionWrapper = styled(InvisibleButton)`
  display: flex;
  flex-direction: row;
  padding: 0px;
  width: 100%;
`;

export const NavItemWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin: auto;
`;

export const StyledTooltip = styled(Tooltip)`
  .rs-tooltip-arrow {
    display: none;
  }

  .rs-tooltip-inner {
    background-color: #101938;
    opacity: 0.8;
    height: 28px;
    margin-left: -20px;

    display: flex;
    align-items: center;
  }
`;

const scaleInCenter = keyframes`
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const animation = () => css`
  ${scaleInCenter} 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
`;

export const NavItemActiveIndicator = styled.div<{ isActive: boolean }>`
  width: ${cssVars.width.verticalNavActiveMarker};
  height: 52px;
  background-color: ${(props) => (props.isActive ? '#37a3bc' : undefined)};
  animation: ${(props) => (props.isActive ? animation : undefined)};
`;

/**
 * the attrs is powerful
 * we can pass functions and objects to override the props
 */
export const StyledIcon = styled(Icon).attrs({
  width: '24px',
  height: '24px',
})<{ isActive: boolean; disabled: boolean }>`
  color: ${(props) => (props.isActive ? '#37A3BC' : 'initial')};
  opacity: ${(props) => (props.disabled ? 0.35 : 1)};
`;

export const StyledIconWrapper = styled.div`
  margin-left: 20px;
`;
